import { render, staticRenderFns } from "./dropdownSideMenuHor.vue?vue&type=template&id=117ad111&scoped=true"
import script from "./dropdownSideMenuHor.vue?vue&type=script&lang=js"
export * from "./dropdownSideMenuHor.vue?vue&type=script&lang=js"
import style0 from "./dropdownSideMenuHor.vue?vue&type=style&index=0&id=117ad111&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ad111",
  null
  
)

export default component.exports